import {
  getActiveCoverLevelOption,
  getCurrentQuote,
  isAuthenticated,
} from '../../../../domain'
import { getCoverOptionConfig } from '../../../../state/configuration'
import { CheckoutConfigContext } from './types'

export const always = () => true

export const isNotAuthenticated = ({ principal, policyholder }: CheckoutConfigContext) =>
  !isAuthenticated(policyholder, principal)

export const hasFinalMile = ({ product }: CheckoutConfigContext) =>
  Boolean(product.finalMile?.form?.length ?? false)

export const hasAddons = ({ product, proposal }: CheckoutConfigContext) => {
  const quote = getCurrentQuote(proposal)
  const coverLevelOption = getActiveCoverLevelOption(quote)

  const { covers } = getCoverOptionConfig(product, coverLevelOption?.coverLevel) ?? {}

  return covers?.optional?.some((it) => !it.form) ?? false
}
